import { render, staticRenderFns } from "./MoleculeCardNonResponsive.vue?vue&type=template&id=3b555ea5&scoped=true"
import script from "./MoleculeCardNonResponsive.vue?vue&type=script&setup=true&lang=js"
export * from "./MoleculeCardNonResponsive.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b555ea5",
  null
  
)

export default component.exports